<div class="detail-page-card">
    @if (tab && tab.name) {
        <div class="detail-page-card-title">{{ tab.name }}</div>
    }
    <div class="detail-page-card-actions">
        <button class="btn btn-raised" (click)="loadHistory()" [disabled]="isLoading">
            <i class="fas fa-sync"></i>
            <span>Reload</span>
        </button>
    </div>

    @if (isLoading) {
        <div class="fancy-loader my-4"></div>
    } @else {
        @if (historyModels) {
            <div class="detail-page-card-body flush-expansion-panels">
                <mat-accordion>
                    @for (historyModel of historyModels; track historyModel) {
                        <mat-expansion-panel (opened)="loadChanges(historyModel)">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{ historyModel.MutationDate | dateTimeFormat: true }}
                                </mat-panel-title>
                                <mat-panel-description>
                                    {{ historyModel.MutationAction }} by {{ historyModel.UserName }}
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <ng-template matExpansionPanelContent>
                                @if (HistoryDetailModel) {
                                    @if (HistoryDetailModel.changes) {
                                        <div>
                                            @if (HistoryDetailModel.changes.length > 0) {
                                                <fieldset class="well fieldset">
                                                    <legend class="legend">Form changes</legend>
                                                    <history-detail
                                                        [changes]="HistoryDetailModel.changes"
                                                    ></history-detail>
                                                </fieldset>
                                            }
                                            @for (
                                                pageChange of HistoryDetailModel.pageChanges;
                                                track pageChange
                                            ) {
                                                <div>
                                                    @if (pageChange.changes.length > 0) {
                                                        <fieldset class="well fieldset indent-1">
                                                            <legend class="legend">
                                                                Page changes ({{ pageChange.name }})
                                                            </legend>
                                                            <history-detail
                                                                [changes]="pageChange.changes"
                                                            ></history-detail>
                                                        </fieldset>
                                                    }
                                                    @for (
                                                        fieldChange of pageChange.fieldChanges;
                                                        track fieldChange
                                                    ) {
                                                        <div>
                                                            @if (
                                                                pageChange.fieldChanges.length > 0
                                                            ) {
                                                                <fieldset
                                                                    class="well fieldset indent-2"
                                                                >
                                                                    <legend class="legend">
                                                                        Field changes (Page:
                                                                        {{ pageChange.name }} ->
                                                                        Field:
                                                                        {{ fieldChange.name }})
                                                                    </legend>
                                                                    <history-detail
                                                                        [changes]="
                                                                            fieldChange.changes
                                                                        "
                                                                    ></history-detail>
                                                                </fieldset>
                                                            }
                                                            @for (
                                                                documentChange of fieldChange.documentChanges;
                                                                track documentChange
                                                            ) {
                                                                <div>
                                                                    @if (
                                                                        fieldChange.documentChanges
                                                                            .length > 0
                                                                    ) {
                                                                        <fieldset
                                                                            class="well fieldset indent-3"
                                                                        >
                                                                            <legend class="legend">
                                                                                Field changes (Page:
                                                                                {{
                                                                                    pageChange.name
                                                                                }}
                                                                                -> Field:
                                                                                {{
                                                                                    fieldChange.name
                                                                                }})
                                                                            </legend>
                                                                            <history-detail
                                                                                [changes]="
                                                                                    documentChange.changes
                                                                                "
                                                                            ></history-detail>
                                                                        </fieldset>
                                                                    }
                                                                </div>
                                                            }
                                                        </div>
                                                    }
                                                    @for (
                                                        workflowChange of pageChange.workflowChanges;
                                                        track workflowChange
                                                    ) {
                                                        <div>
                                                            @if (
                                                                pageChange.workflowChanges.length >
                                                                0
                                                            ) {
                                                                <fieldset
                                                                    class="well fieldset indent-2"
                                                                >
                                                                    <legend class="legend">
                                                                        Workflow page definition
                                                                        changes (Page:
                                                                        {{ pageChange.name }})
                                                                    </legend>
                                                                    <history-detail
                                                                        [changes]="
                                                                            workflowChange.changes
                                                                        "
                                                                    ></history-detail>
                                                                </fieldset>
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    }
                                } @else {
                                    <div class="fancy-loader submodule my-4"></div>
                                }
                            </ng-template>
                        </mat-expansion-panel>
                    }
                </mat-accordion>
            </div>
        } @else {
            <div class="detail-page-card-body padded text-center">History not available.</div>
        }
    }
</div>
